import React from 'react';
import { fetchDailyTransactionReports } from 'apiRequest/transaction-report';
import TransactionReportPageContainer from 'components/TransactionReportPageContainer';

export default function TransactionReportDaily() {
  return (
    <TransactionReportPageContainer fetch={fetchDailyTransactionReports} />
  );
};
